// extracted by mini-css-extract-plugin
module.exports = {"horizontal-scrolling":"DashboardViewDataModal_horizontal-scrolling__3Pc3f"};